var map = {
	"./bondingcurve.json": 22843,
	"./lplocker.json": 55325,
	"./marspump.json": 21593,
	"./marspump_v2.json": 79389,
	"./powerpool.json": 24872,
	"./token.json": 77543,
	"./tokenpool.json": 40599,
	"./uniswapQuoterV2.json": 86169,
	"./uniswapRouterV3.json": 82780,
	"./v3pool.json": 56537
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6169;